import React, { useState } from 'react'
import { StateProvider } from '../stores/admin_templates'

import TemplateFilter from './AdminTemplates/Filter'
import TemplateList from './AdminTemplates/List'
import DeleteTemplateModal from './AdminTemplates/DeleteTemplateModal'

const AdminTemplates = (props) => {
  return (
    <StateProvider {...props}>
      <TemplateFilter />
      <TemplateList />
      <DeleteTemplateModal />
    </StateProvider>
  )
}

export default AdminTemplates
